module.exports = __webpack_public_path__ + "img/carWeb.9bd30e29.png";